export default __webpack_public_path__ + "static/media/01_Kom_Oxford A4.e6323fcb.png";